<template>
  <div>
    <div class="header px-4 py-1">
      <div class="d-flex align-center">
        <div class="font-weight-regular flex-fill">
          <small> Es necesario que ingreses tus datos para poder {{ room.data.data_rule === 'default' ? 'interactuar con la transmisión' : 'visualizar la trasmisión' }} </small>
        </div>
        <div v-if="room.data.data_rule === 'default'">
          <v-btn
            fab
            x-small
            elevation="0"
            class="ml-3"
            @click="$emit('hideCustomer')"
          >
            <Icon
              :width="24"
              :color="'rgba(0,0,0,.54)'"
              :icon="'close'"
            />
          </v-btn>
        </div>
      </div>
    </div>
    <div class="body px-4 py-5">
      <form v-on:submit.prevent="submitHandler">
        <v-text-field
          label="Nombre"
          placeholder="Ingresa tu nombre"
          :required="requiredData.name.required"
          type="text"
          v-model="form.data.name"
          outlined
          hide-details
          dense
          class="mb-2"
        ></v-text-field>
        <v-text-field
          label="Correo"
          placeholder="Ingresa tu correo electrónico"
          :required="requiredData.email.required"
          type="email"
          v-model="form.data.email"
          outlined
          hide-details
          dense
          class="mb-2"
        ></v-text-field>
        <v-text-field
          label="Num de identificación"
          placeholder="Ingresa tu identificación"
          :required="requiredData.identification.required"
          type="number"
          v-model="form.data.identification"
          outlined
          hide-details
          dense
          class="mb-4"
          v-if="requiredData.identification"
        ></v-text-field>
        <div
          id="actions"
          class="mb-2"
        >
          <v-btn
            block
            color="primary"
            small
            type="submit"
            :loading="loadingButton"
          >
            Guardar mis datos
          </v-btn>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    customer: {
      type: Object,
      default: null
    },
    loadingButton: {
      type: Boolean,
      default: false
    },
    requiredData: {
      type: Object,
      default: null
    },
    room: {
      type: Object,
      default: null
    }
  }
})
export default class Customer extends Vue {
  data () {
    return {
      form: {
        data: {
          name: '',
          email: '',
          identification: ''
        }
      }
    }
  }

  mounted () {
    if (this.customer) {
      this.form.data.name = this.customer.name ?? ''
      this.form.data.email = this.customer.email ?? ''
      this.form.data.identification = this.customer.identification ?? ''
    }
  }

  submitHandler () {
    this.$emit('saveCustomer', this.form.data)
  }
}
</script>
